//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCajaChicasTalca } from "@/typings/store/plugins/easyFirestore/cajaChicasTalca";

const getters: GetterTree<StateCajaChicasTalca, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const cajaChicasTalca = {
    firestorePath: "dev/v1/cajaChicasTalca",
    firestoreRefType: "collection",
    moduleName: "cajaChicasTalca",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default cajaChicasTalca;
